<template>
  <a
    class="ss__desktop__menu__series__item"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <img
      :src="$formatImageSrc(item.image, { w: 240, h: 320 }) || $app.imgErrorSrc"
      :alt="item.name"
      class="ss__desktop__menu__series__item__image"
    />
    <div class="ss__desktop__menu__series__item__desc">{{ item.description }}</div>
  </a>
</template>

<script>
export default {
  name: 'SsDesktopMenuSeriesItem',

  props: {
    item: Object
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__menu__series__item {
  .ss__desktop__menu__series__item__image {
    width: var(--w-SsDesktopMenuSeriesItemImage, 120px);
    height: var(--h-SsDesktopMenuSeriesItemImage, 160px);
    border-radius: var(--radius-SsDesktopMenuSeriesItemImage, 4px);
    border: var(--border-SsDesktopMenuSeriesItemImage, (1px solid rgba(0, 0, 0, 0.05)));
    margin: var(--margin-SsDesktopMenuSeriesItemImage, (0px 0px 8px));
    object-fit: cover;
    box-sizing: border-box;
  }
  .ss__desktop__menu__series__item__desc {
    width: var(--h-SsDesktopMenuSeriesItemDesc, 120px);
    font-size: var(--text-SsDesktopMenuSeriesItemDesc, 13px);
    color: var(--color-SsDesktopMenuSeriesItemDesc, var(--B6-t));
    font-weight: var(--weight-SsDesktopMenuSeriesItemDesc, 400);
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
